import CustomSlider from "../components/commonBack/CustomSlider";

export const isInViewport = (el) => {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

export const findAvailableSize = (imageSizes, desiredSize) => {
	return Object.keys(imageSizes).includes(desiredSize) &&
		imageSizes[desiredSize]
		? imageSizes[desiredSize].source_url
		: imageSizes["full"].source_url;
};

export const renderSingleImage = ({
	image,
	size = "large",
	customClass = "",
}) => (
	<figure className={customClass}>
		<img src={findAvailableSize(image.media_details.sizes, size)} alt="" />
	</figure>
);

export const renderSwiperMultipleImages = ({
	images,
	customClass = "",
	createSlider,
}) => (
	<CustomSlider
		createSlider={createSlider}
		items={images.map((image) => (
			<figure>
				<img
					src={findAvailableSize(image.media_details.sizes, "large")}
					alt=""
					loading="lazy"
				/>
			</figure>
		))}
		customClass={customClass}
	/>
);

export const addLeadingZero = (index) => {
	return index < 10 ? "0" + index : index;
};
